import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import BottomNav from "../components/BottomNav";
import InternalHeader from "../components/InternalHeader";
import { api } from "../lib/api";
import { useLocale } from "../context/Locale";

export default function ReviewsPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { t } = useLocale();

  useEffect(() => {
    api(`/get-store-reviews/${slug}`)
      .then(setData)
      .catch((requestError) => setError(requestError.message))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <main className="food-app reviews-page">
      <InternalHeader title={t("reviews")} backTo={`/food/stores/${slug}`} />
      {loading && <div className="food-message"><b>Cargando opiniones…</b></div>}
      {error && <div className="food-message food-message--error"><b>{error}</b></div>}
      {data && (
        <>
          <header className="reviews-heading">
            <img src={data.restaurant?.image} alt="" />
            <div>
              <small>{t("reviews")}</small>
              <h1>{data.restaurant?.name}</h1>
              <strong>★ {data.restaurant?.avgRating || "0"}</strong>
            </div>
          </header>
          {!data.reviews?.length && <div className="food-message"><b>{t("noReviews")}</b></div>}
          <section className="review-list">
            {data.reviews?.map((review) => (
              <article key={review.id}>
                <header><b>{review.username || "Cliente"}</b><span>★ {review.rating_store}</span></header>
                <p>{review.review_store || "Calificación sin comentario."}</p>
              </article>
            ))}
          </section>
        </>
      )}
      <BottomNav />
    </main>
  );
}
